type RequestKind =
  | 'ucoo_status_bar_height'
  | 'ucoo_h5_jump_app'
  | 'ucoo_finish'
  | 'ucoo_toast'
  | 'hifun_get_room_id'
  | 'hifun_get_seat_users'
  | 'registerCmd'
  | 'onReceiveCmd'
  | 'playEffect'
  | 'ucoo_app_version'

type ListenKind = 'hifunSeatChangeMessage'

type DeepLink = 'user_home' | 'hifun://page/my_chatroom' | 'hifun://page/noble'

// 有target_name的都用这个, 专注于跳转
export function H5JumpApp(
  target_name: string,
  params?: unknown,
  successCB?: (data: unknown) => void,
  failCB?: (msg: unknown) => void
) {
  console.log('H5JumpApp ' + target_name + JSON.stringify(params))
  window.setupWebViewJavascriptBridge(bridge => {
    let data = JSON.stringify({ target_name: target_name, params: params })
    console.log('H5JumpApp---> ', data)

    bridge.callHandler('ucoo_h5_jump_app', data, (result: string) => {
      let resultData = JSON.parse(result)
      if (resultData.status === 0) {
        successCB && successCB(resultData.data)
      } else {
        failCB && failCB(resultData.msg)
      }
    })
  })
}

// JSbridge调用 requestApp
export function requestApp(requestKind: RequestKind, deepLink?: DeepLink, params?: Record<string, string | number>) {
  return new Promise((resolve, reject) => {
    window.setupWebViewJavascriptBridge(bridge => {
      const data = JSON.stringify({ target_name: deepLink, params: params })
      bridge.callHandler(requestKind, data, (result: string) => {
        const resultData = JSON.parse(result)
        if (resultData.status === 0) {
          resolve(resultData.data)
        } else {
          reject(resultData.msg)
        }
      })
    })
  })
}

export function requestApp2(requestKind: RequestKind, params?: Record<string, string | number>) {
  return new Promise((resolve, reject) => {
    window.setupWebViewJavascriptBridge(bridge => {
      const data = JSON.stringify({ ...params })
      bridge.callHandler(requestKind, data, (result: string) => {
        const resultData = JSON.parse(result)
        if (resultData.status === 0) {
          console.log('requestApp success', requestKind, resultData.data)
          resolve(resultData.data)
        } else {
          console.log('requestApp error', requestKind)
          reject(resultData.msg)
        }
      })
    })
  })
}

// 监听App
export function listenApp(requestKind: ListenKind, callback: (data: unknown) => void) {
  window.setupWebViewJavascriptBridge(bridge => {
    bridge.registerHandler(requestKind, function (data: unknown, responseCallback: (data: unknown) => void) {
      console.log('registerHandler:', requestKind)
      responseCallback(callback(data))
    })
  })
}
